import { Fragment } from "react";
import { Grid, Button, Typography as MuiTypography } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { BiErrorCircle } from "react-icons/bi";

const Icon = styled(BiErrorCircle)`
  width: 80px;
  height: 80px;
  color: red;
`;

const Typography = styled(MuiTypography)`
  text-align: center;
`;

export default function APIError({ disableHomeButton }) {
  const loader = useSelector((state) => state.loaderDetails);
  const navigate = useNavigate();

  return (
    <Fragment>
      <Grid container spacing={2} justifyContent="center">
        <Grid item>
          <Icon />
        </Grid>

        <Grid item xs={12}>
          <Typography variant="h5">{loader.message}</Typography>
        </Grid>

        {!disableHomeButton && (
          <Grid item>
            <Button variant="contained" onClick={() => navigate(-1)}>
              Back
            </Button>
          </Grid>
        )}

        <Grid item>
          <Button variant="contained" onClick={() => window.location.reload()}>
            Retry
          </Button>
        </Grid>
      </Grid>
    </Fragment>
  );
}
